"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasMissingData = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var icons_1 = require("../../common/icons");
var AuthStore = __importStar(require("../../app/store/AuthStore"));
var UserStore = __importStar(require("../../app/store/UserStore"));
var constants_1 = require("../../youwell-common/constants");
var components_1 = require("../../common/components");
var validation_1 = require("./components/validation");
var components_2 = require("../../youwell-common/components");
var urls_1 = __importDefault(require("../../app/urls"));
var arrayUtils_1 = require("../../youwell-common/arrayUtils");
var apiUrls_1 = __importDefault(require("../../youwell-common/apiUrls"));
var objectUtils_1 = require("../../youwell-common/objectUtils");
var useForm_1 = __importDefault(require("../../youwell-common/useForm"));
var breadcrumbUtil_1 = require("../../common/breadcrumbUtil");
var ProfileImageEditor_1 = __importDefault(require("./components/ProfileImageEditor"));
var store_1 = require("../../app/store");
var translate_1 = __importDefault(require("../../app/localization/translate"));
var useStyles = (0, core_1.makeStyles)(function (theme) { return ({
    root: {
        padding: theme.spacing(1),
    },
    header: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    profileData: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
    },
    topItems: {
        display: 'flex',
    },
    topLeft: {
        flex: '1 1 50%',
        display: 'flex',
        flexDirection: 'column',
    },
    profileImage: {
        border: theme.youwell.borders.dim,
        margin: theme.spacing(2),
        width: 200,
        minHeight: 200,
    },
    textField: {
        marginBottom: theme.spacing(3),
    },
    actions: {
        marginTop: theme.spacing(1),
        display: 'flex',
        justifyContent: 'flex-end',
    },
    content: {
        margin: theme.spacing(4, 0),
        borderTop: theme.youwell.borders.dim,
        paddingTop: theme.spacing(4),
    },
    contentActions: {
        marginTop: theme.spacing(1),
        display: 'flex',
        justifyContent: 'space-between',
    },
    patientDataMissing: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3),
        borderRadius: theme.youwell.shapes.borderRadius,
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.contrastText,
    },
    bottomActions: {
        margin: theme.spacing(8, 0, 4),
        borderTop: theme.youwell.borders.dim,
        paddingTop: theme.spacing(4),
        display: 'flex',
        justifyContent: 'flex-end',
    },
    saveButton: {
        marginLeft: theme.spacing(1),
    },
    buttonIcon: {
        marginRight: theme.spacing(1),
    },
    currentOrg: {
        background: theme.palette.grey[200],
    },
}); });
var hasMissingData = function (profileData, clientConfig) {
    if ((profileData === null || profileData === void 0 ? void 0 : profileData.userLevel) === constants_1.patientUserLevels.person) {
        return !profileData.name || !profileData.phone || !profileData.email;
    }
    if ((profileData === null || profileData === void 0 ? void 0 : profileData.userLevel) === constants_1.patientUserLevels.patient) {
        if (clientConfig.appSetup.features.emailL4) {
            return !profileData.name || !profileData.phone || !profileData.email;
        }
        return !profileData.name || !profileData.phone;
    }
    return false;
};
exports.hasMissingData = hasMissingData;
var defaultState = {
    userLevel: '',
    username: '',
    email: '',
    phone: '',
    fnr: '',
    name: '',
    sex: '',
    birthDate: '',
    height: '',
    weight: '',
    newPassword: '',
    newPasswordConfirm: '',
};
var stateFromData = function (data) {
    var initialState = __assign({}, defaultState);
    if (!data) {
        return initialState;
    }
    return Object.keys(defaultState).reduce(function (obj, key) {
        var _a;
        return ((0, objectUtils_1.hasValue)(data[key]) ? __assign(__assign({}, obj), (_a = {}, _a[key] = data[key], _a)) : __assign({}, obj));
    }, __assign(__assign({}, initialState), { isInitializedWithData: true }));
};
var Profile = function () {
    var _a, _b, _c, _d;
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var translate = (0, translate_1.default)();
    var profileData = (0, store_1.useYouwellSelector)(function (state) { return state.auth.profileData; });
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    var hasActiveProgram = (0, store_1.useYouwellSelector)(function (state) { var _a; return (_a = state.programStore.currentProgram) === null || _a === void 0 ? void 0 : _a.isActiveProgram; });
    var patientDataMissing = clientConfig.appSetup.patient.checkMissingData && (0, exports.hasMissingData)(profileData, clientConfig);
    var _e = (0, react_1.useState)(false), editing = _e[0], setEditing = _e[1];
    var validators = (0, validation_1.getRuleValidators)(profileData === null || profileData === void 0 ? void 0 : profileData.userLevel);
    var send = function (_a) {
        var _b;
        var formValues = _a.formValues;
        if (!profileData)
            return;
        var saveData = Object.keys(formValues).reduce(function (prev, curr) {
            var _a;
            return ((0, objectUtils_1.hasValue)(formValues[curr]) ? __assign(__assign({}, prev), (_a = {}, _a[curr] = formValues[curr], _a)) : prev);
        }, {
            id: profileData.id,
            organizationId: (_b = profileData.organization) === null || _b === void 0 ? void 0 : _b.id,
            userLevel: profileData.userLevel,
            userSettings: profileData.userSettings,
        });
        delete saveData.isInitializedWithData;
        switch (saveData.userLevel) {
            case constants_1.patientUserLevels.none: {
                break;
            }
            case constants_1.patientUserLevels.anonymous: {
                delete saveData.fnr;
                delete saveData.email;
                delete saveData.name;
                delete saveData.phone;
                break;
            }
            case constants_1.patientUserLevels.person: {
                delete saveData.username;
                delete saveData.fnr;
                break;
            }
            case constants_1.patientUserLevels.patient: {
                delete saveData.username;
                delete saveData.newPassword;
                break;
            }
            default: {
                break;
            }
        }
        var callback = function () {
            setEditing(false);
        };
        dispatch(AuthStore.actionCreators.saveUserProfile(saveData, { callback: callback, redirect: patientDataMissing ? urls_1.default.inside.home : undefined }));
    };
    var _f = (0, useForm_1.default)(send, validators, stateFromData(profileData)), handleChange = _f.handleChange, handleSubmit = _f.handleSubmit, formValues = _f.formValues, validationErrors = _f.validationErrors, resetForm = _f.resetForm;
    var handleConfigChange = function (name) { return function (event) {
        var _a;
        var userSettings = __assign(__assign({}, profileData === null || profileData === void 0 ? void 0 : profileData.userSettings), (_a = {}, _a[name] = event.target.checked, _a));
        dispatch(AuthStore.actionCreators.updateUserSettings(userSettings));
    }; };
    var startEdit = function () {
        setEditing(true);
    };
    var cancelEditing = function () {
        setEditing(false);
        resetForm();
    };
    var removeSensor = function (sensor) { return function () {
        dispatch(UserStore.actionCreators.removeSensor(sensor));
    }; };
    var deleteUser = function () {
        dispatch(UserStore.actionCreators.deleteUser(profileData, { redirect: urls_1.default.logout }));
    };
    var saveProfilePicture = function (image, callback) {
        dispatch(UserStore.actionCreators.saveProfilePicture(image, { callback: callback }));
    };
    var deleteProfilePicture = function (callback) {
        dispatch(UserStore.actionCreators.deleteProfilePicture({ callback: callback }));
    };
    var logoutOrg = function () {
        dispatch(AuthStore.actionCreators.logoutOrg());
    };
    (0, react_1.useEffect)(function () {
        if (profileData && !formValues.isInitializedWithData) {
            resetForm();
        }
    }, [formValues.isInitializedWithData, profileData, resetForm]);
    if (!profileData) {
        return null;
    }
    var sensors = (0, arrayUtils_1.toBoolLookup)(profileData.sensors, 'sensorType');
    var allowIdentifyingInformation = formValues.userLevel !== constants_1.patientUserLevels.anonymous;
    var showPassword = clientConfig.appSetup.patient.useUserNameAndPw || formValues.userLevel === constants_1.patientUserLevels.person;
    var allowEmail = formValues.userLevel !== constants_1.patientUserLevels.patient || clientConfig.appSetup.features.emailL4;
    var isEditing = editing || patientDataMissing;
    return (react_1.default.createElement(components_1.PageLayout, { title: translate('profile.profileHeading'), breadcrumb: (0, breadcrumbUtil_1.getBreadCrumb)(translate('profile.profile'), translate, clientConfig) },
        react_1.default.createElement("form", { onSubmit: handleSubmit },
            react_1.default.createElement("div", { className: classes.profileData },
                patientDataMissing && (react_1.default.createElement("div", { className: classes.patientDataMissing },
                    react_1.default.createElement(core_1.Typography, null, translate('profile.patientDataMissing')))),
                react_1.default.createElement("div", { className: classes.topItems },
                    react_1.default.createElement("div", { className: classes.topLeft },
                        clientConfig.appSetup.patient.useUserNameAndPw && (react_1.default.createElement(core_1.TextField, { className: classes.textField, label: translate('profile.username'), value: formValues.username, onChange: handleChange('username'), disabled: !isEditing, error: !!validationErrors.username, helperText: validationErrors.username ? translate(validationErrors.username) : null })),
                        allowIdentifyingInformation && (react_1.default.createElement(core_1.TextField, { className: classes.textField, label: translate('profile.name'), value: formValues.name, onChange: handleChange('name'), disabled: !isEditing, error: !!validationErrors.name, helperText: validationErrors.name ? translate(validationErrors.name) : null })),
                        allowIdentifyingInformation && clientConfig.appSetup.patient.mailAndPhone && (react_1.default.createElement(react_1.default.Fragment, null,
                            allowEmail && (react_1.default.createElement(core_1.TextField, { className: classes.textField, label: translate('profile.email'), value: formValues.email, onChange: handleChange('email'), disabled: !isEditing, error: !!validationErrors.email, helperText: validationErrors.email ? translate(validationErrors.email) : null })),
                            react_1.default.createElement(core_1.TextField, { className: classes.textField, label: translate('profile.phone'), value: formValues.phone, onChange: handleChange('phone'), disabled: !isEditing, error: !!validationErrors.phone, helperText: validationErrors.phone ? translate(validationErrors.phone) : null })))),
                    allowIdentifyingInformation && clientConfig.appSetup.patient.profilePicture && (react_1.default.createElement("div", { className: classes.profileImage },
                        react_1.default.createElement(ProfileImageEditor_1.default, { currentImageId: profileData.profileImageId, onSave: saveProfilePicture, onDelete: deleteProfilePicture })))),
                clientConfig.appSetup.patient.sexAndBirthDate && formValues.userLevel !== constants_1.patientUserLevels.patient && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.TextField, { className: classes.textField, label: translate('profile.sex'), value: formValues.sex, onChange: handleChange('sex'), disabled: !isEditing, select: true },
                        react_1.default.createElement(core_1.MenuItem, { value: "" }, translate('profile.select_sex')),
                        react_1.default.createElement(core_1.MenuItem, { value: "male" }, translate('profile.male')),
                        react_1.default.createElement(core_1.MenuItem, { value: "female" }, translate('profile.female')),
                        react_1.default.createElement(core_1.MenuItem, { value: "other" }, translate('profile.other'))),
                    react_1.default.createElement(core_1.TextField, { className: classes.textField, type: "date", InputLabelProps: { shrink: true }, label: translate('profile.birthDate'), disabled: !isEditing, value: formValues.birthDate, onChange: handleChange('birthDate') }))),
                clientConfig.appSetup.features.heightWeight && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.TextField, { className: classes.textField, type: "number", label: translate('profile.heightInCm'), value: formValues.height, onChange: handleChange('height'), disabled: !isEditing, error: !!validationErrors.height, helperText: validationErrors.height ? translate(validationErrors.height) : null }),
                    react_1.default.createElement(core_1.TextField, { className: classes.textField, type: "number", label: translate('profile.weightInKg'), value: formValues.weight, onChange: handleChange('weight'), disabled: !isEditing, error: !!validationErrors.weight, helperText: validationErrors.weight ? translate(validationErrors.weight) : null }))),
                showPassword && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_1.TextField, { type: "password", inputProps: { autoComplete: 'off' }, className: classes.textField, label: translate('profile.new_password'), value: formValues.newPassword, disabled: !isEditing, onChange: handleChange('newPassword'), error: !!validationErrors.newPassword, helperText: validationErrors.newPassword ? translate(validationErrors.newPassword) : null }),
                    react_1.default.createElement(core_1.TextField, { type: "password", inputProps: { autoComplete: 'off' }, className: classes.textField, label: translate('profile.new_password_confirm'), value: formValues.newPasswordConfirm, disabled: !isEditing, onChange: handleChange('newPasswordConfirm'), error: !!validationErrors.newPasswordConfirm, helperText: validationErrors.newPasswordConfirm ? translate(validationErrors.newPasswordConfirm) : null })))),
            react_1.default.createElement("div", { className: classes.actions }, isEditing ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Button, { variant: "outlined", onClick: cancelEditing, className: classes.saveButton, color: "secondary" },
                    react_1.default.createElement(icons_1.CancelIcon, null),
                    translate('cancel')),
                react_1.default.createElement(core_1.Button, { variant: "contained", type: "submit", className: classes.saveButton, color: "primary", startIcon: react_1.default.createElement(icons_1.SaveIcon, null) }, translate('common.save')))) : (react_1.default.createElement(core_1.Button, { onClick: startEdit, "aria-label": translate('edit'), variant: "outlined" },
                react_1.default.createElement(icons_1.EditIcon, { className: classes.buttonIcon }),
                translate('profile.change'))))),
        hasActiveProgram && clientConfig.appSetup.features.notifications && allowIdentifyingInformation && (react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(core_1.Typography, { variant: "h6", color: "primary", gutterBottom: true }, translate('profile.notifications')),
            react_1.default.createElement(core_1.Typography, { variant: "caption", display: "block", gutterBottom: true }, translate('profile.notificationsDescription')),
            allowEmail && (react_1.default.createElement(core_1.FormControlLabel, { disabled: !profileData.email, control: (react_1.default.createElement(core_1.Switch, { checked: ((_a = profileData.userSettings) === null || _a === void 0 ? void 0 : _a.allowEmailNotifications) || false, onChange: handleConfigChange('allowEmailNotifications'), value: "allowEmailNotifications" })), label: translate('profile.allowEmailNotifications') })),
            react_1.default.createElement(core_1.FormControlLabel, { disabled: !profileData.phone, control: (react_1.default.createElement(core_1.Switch, { checked: ((_b = profileData.userSettings) === null || _b === void 0 ? void 0 : _b.allowSmsNotifications) || false, onChange: handleConfigChange('allowSmsNotifications'), value: "allowSmsNotifications" })), label: translate('profile.allowSmsNotifications') }))),
        clientConfig.appSetup.features.sensors && (react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(core_1.Typography, { variant: "h6", color: "primary", gutterBottom: true }, translate('profile.mySensors')),
            react_1.default.createElement(core_1.Typography, { variant: "caption", display: "block", gutterBottom: true }, translate('profile.mySensorsDescription')),
            react_1.default.createElement(core_1.List, null, (_c = profileData.sensors) === null || _c === void 0 ? void 0 : _c.map(function (s) { return (react_1.default.createElement(core_1.ListItem, { key: s.id },
                react_1.default.createElement(core_1.ListItemText, { primary: s.name }),
                react_1.default.createElement(core_1.ListItemSecondaryAction, null,
                    react_1.default.createElement(core_1.IconButton, { onClick: removeSensor(s), "aria-label": translate('removeSensor') },
                        react_1.default.createElement(icons_1.DeleteIcon, null))))); })),
            react_1.default.createElement("div", { className: classes.contentActions }, !sensors[constants_1.sensorTypes.fitbit] && (react_1.default.createElement(components_2.FormLink, { to: "".concat(apiUrls_1.default.baseUrl, "/").concat(apiUrls_1.default.route.oauth, "/fitbit"), buttonText: translate('profile.addFitbit'), params: [
                    { key: 'callbackUrl', value: urls_1.default.inside.profile },
                ] }))))),
        ((_d = profileData.connectedOrganizations) === null || _d === void 0 ? void 0 : _d.length) > 1 && (react_1.default.createElement("div", { className: classes.content },
            react_1.default.createElement(core_1.Typography, { variant: "h6", color: "primary", gutterBottom: true }, translate('profile.myPrograms')),
            react_1.default.createElement(core_1.Typography, { variant: "caption", display: "block", gutterBottom: true }, translate('profile.myProgramsDescription')),
            react_1.default.createElement(core_1.List, { dense: true }, profileData.connectedOrganizations.map(function (org) {
                var _a;
                var _b;
                return (react_1.default.createElement(core_1.ListItem, { key: org.id, onClick: logoutOrg, button: true, className: (0, classnames_1.default)((_a = {}, _a[classes.currentOrg] = org.id === ((_b = profileData.organization) === null || _b === void 0 ? void 0 : _b.id), _a)) },
                    react_1.default.createElement(core_1.ListItemText, { primary: org.name })));
            })))),
        react_1.default.createElement("div", { className: classes.bottomActions }, clientConfig.appSetup.features.selfDelete && (react_1.default.createElement(components_1.ConfirmButton, { confirmTitle: translate('profile.deleteUser'), confirmText: translate('profile.reallyDeleteUser'), onClick: deleteUser, danger: true }, translate('profile.deleteUser'))))));
};
exports.default = Profile;
